module.exports = __webpack_public_path__ + "img/Gallery_2_21.3d5789d9.jpeg";